import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-discount-person',
  templateUrl: './discount-person.component.html',
  styleUrls: ['./discount-person.component.css']
})
export class DiscountPersonComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
